export default __webpack_public_path__ + "static/media/Little-boy.9342c12b.png";